"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeTransformer = void 0;
var CodeTransformer;
(function (CodeTransformer) {
    CodeTransformer["HashbangOperatorTransformer"] = "HashbangOperatorTransformer";
})(CodeTransformer = exports.CodeTransformer || (exports.CodeTransformer = {}));
